"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DLP_WORDINGS = void 0;
exports.DLP_WORDINGS = {
    FULL: 'Vous ne pouvez pas sélectionner ce point de retrait car il est complet. Veuillez en sélectionner un autre avant de valider votre abonnement.',
    NOT_IN_SAME_REGION: 'Vous ne pouvez pas choisir ce point car il est en dehors de votre région. Contactez-le service client si vous souhaitez changer de région.',
    PRIVATE_WARNING: "Vous acc\u00E9dez \u00E0 la recherche d\u2019un point de retrait priv\u00E9 dont l\u2019entreprise a un partenariat avec Potager City. Si vous choisissez un point de retrait priv\u00E9, vous devez \u00EAtre autoris\u00E9(e) \u00E0 vous rendre dans l'\u00E9tablissement pour r\u00E9cup\u00E9rer vos commandes.",
};
exports.default = exports.DLP_WORDINGS;
//# sourceMappingURL=DeliveryPoint.js.map